import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface setMerchantTrainingPdfFormInterface {
    pdfUrl: string
}

export const fetchMerchantTrainingPdf = async (): Promise<{ pdfUrl: string }> => {
    const response = await baseAxios.get<{ pdfUrl: string }>('/api/serviceProviderConfiguration/merchantTraining/pdf');

    return response.data;
};

export const setMerchantTrainingPdf = async (form: setMerchantTrainingPdfFormInterface): Promise<void> => {
    await baseAxios.post('/api/serviceProviderConfiguration/merchantTraining/pdf', {
        pdfUrl: form.pdfUrl,
    });
};

export default (axios: AxiosInstance = baseAxios): { fetchMerchantTrainingPdf: () => Promise<{ pdfUrl: string; }>; setMerchantTrainingPdf: (form: setMerchantTrainingPdfFormInterface) => Promise<void>; } => ({
    fetchMerchantTrainingPdf: async (): Promise<{ pdfUrl: string }> => {
        const response = await axios.get<{ pdfUrl: string }>('/api/serviceProviderConfiguration/merchantTraining/pdf');

        return response.data;
    },

    setMerchantTrainingPdf: async (form: setMerchantTrainingPdfFormInterface): Promise<void> => {
        await axios.post('/api/serviceProviderConfiguration/merchantTraining/pdf', {
            pdfUrl: form.pdfUrl,
        });
    },
});
